export function getRoomOrganization(
  room: { organisationModel: { uid: string } } | null
) {
  const uid = room?.organisationModel.uid.toLowerCase() ?? "";

  return {
    isBiocodexRoom: uid.includes("biocodex"),
    isBiomerieuxRoom: uid.includes("biomerieux"),
    isChiesiRoom: uid.includes("chiesi"),
    isEdwardsRoom: uid.includes("edwards"),
    isOpellaRoom: uid.includes("opella"),
    isPierreFabreRoom: uid.includes("pierre-fabre"),
    isTakedaRoom: uid.includes("takeda"),
    isUcbRoom: uid.includes("ucb"),
    isViforRoom: uid.includes("vifor"),
  };
}
